import { InfoBox, InfoRow } from './InfoBox';

/**
 * Compact Moderation History card (Figma User Details / DetailsScreen.kt:503-563).
 * Number of Reports, Current Restrictions, and Implement penalty (ban).
 */
export function ModerationHistoryPanel({
  numberOfReports,
  canModerate,
  isBanned,
  onBan,
  isBanning,
  onViewReports,
}: {
  numberOfReports: number | null | undefined;
  canModerate: boolean;
  isBanned: boolean;
  onBan: () => void;
  isBanning: boolean;
  onViewReports?: () => void;
}) {
  return (
    <InfoBox
      title="Moderation History"
      actions={
        canModerate
          ? [
              {
                label: isBanned ? 'User Banned' : 'Implement penalty',
                variant: 'destructive',
                onClick: onBan,
                disabled: isBanning || isBanned,
              },
            ]
          : undefined
      }
    >
      <InfoRow
        label="Number of Reports"
        value={String(numberOfReports ?? 0)}
        clickable={!!onViewReports}
        {...(onViewReports ? { onClick: onViewReports } : {})}
      />
      <InfoRow label="Current Restrictions" value={isBanned ? 'Banned' : 'None'} />
    </InfoBox>
  );
}
